// Author THQ
// Date 2025-03-05 00:04:55

import * as model from "@/model/em/ppe/PpeApplyRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeApplyRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
        callbackApi: process.env.VUE_APP_EM_PPE_URL + '/ppeApplyRecord/workflow/complete-feedback',
        processDefinitionKey: "ppe_apply_record",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
